module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.10766/images/default-share-image.png"